<div>
  <!--<div class="header-bg">
    <div class="container-fluid p-24">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-lg-6 m-y-10">
          <h4 class="text-dark f-s-20 f-w-700  m-l-10">
            My Account
          </h4>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 flexmobile text-right m-y-10">
          <div class="d-flex  align-items-center justify-content-end gap-8 ">
            @if(((this.numberOfUsers != 'Unlimited') || (this.noOfCharities != 'Unlimited') ) ){
            @if(this.showupgrade){
            <button [disabled]="!IsAdmin" class="" mat-flat-button (click)="Upgrade('Upgrade')">
              <i-tabler name="crown" class="icon-20 m-x-3"></i-tabler><span class="labelhide">Upgrade</span>
            </button>
            }
            }
            @if(this.ShowRenew == true){
            <button [disabled]="!IsAdmin" class="bg-error" mat-flat-button (click)="Upgrade('Renew')">
              <i-tabler name="progress-check" class="icon-20 m-x-3"></i-tabler> <span class="labelhide">Renew</span>
            </button>
            }
            <button mat-icon-button mat-dialog-close class="d-flex justify-content-center" (click)="close()">
              <i-tabler name="X" class="icon-20 m-r-2"></i-tabler>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>-->

  <div class="b-b-1">
    <div class="container-fluid p-x-30 p-y-10">
      <div class="row align-items-center">

        <!-- Left side (Heading) -->
        <div class="col-lg-6 col-md-12 d-flex align-items-center">
          <h4 class="text-dark f-s-20 f-w-700 m-t-0 m-l-10 d-flex align-items-center">
            <img src="../../../assets/images/logos/logomini-dark.png"
                 width="30px"
                 class="m-r-10" />
            <span class="f-s-18 titleHide">Andica Charity Accounts</span>
          </h4>
        </div>

        <!-- Right side (Buttons) -->
        <div class="col-lg-6 col-md-12 d-flex justify-content-lg-end justify-content-end mt-md-3 mt-lg-0">
          <div class="d-flex align-items-center gap-8 flex-wrap">

            @if(((this.numberOfUsers != 'Unlimited') || (this.noOfCharities != 'Unlimited'))){
            @if(this.showupgrade){
            <button [disabled]="!IsAdmin" mat-flat-button (click)="Upgrade('Upgrade')">
              <i-tabler name="crown" class="icon-20 m-x-3"></i-tabler>
              <span class="labelhide">Upgrade</span>
            </button>
            }
            }

            @if(this.ShowRenew == true){
            <button [disabled]="!IsAdmin" class="bg-error" mat-flat-button (click)="Upgrade('Renew')">
              <i-tabler name="progress-check" class="icon-20 m-x-3"></i-tabler>
              <span class="labelhide">Renew</span>
            </button>
            }

            <button mat-icon-button mat-dialog-close (click)="close()">
              <i-tabler name="X" class="icon-20 m-r-2"></i-tabler>
            </button>

          </div>
        </div>

      </div>

    </div>
  </div>


  <div class="p-x-30 heiDet">
    <!--<div class="profile-header p-20 rounded">-->
    <!--<div class="profile-header m-t-16 p-20 rounded">-->
    <div class="profile-header m-t-16 p-20" style="border-radius:6px !important;">
      <!--<div mat-card-avatar class="profile-avatar"> {{ UserName().charAt(0) }}{{ UserName().charAt(1) }}  </div>-->  <!--recheckin-->
      <div mat-card-avatar class="profile-avatar"> {{ UserName().charAt(0) }}</div>             <!--recheckin-->
      <div class="profile-info">
        <div class="d-flex">
          <h2 class="mat-h2" style="font-size:20px;">{{ UserName() }}</h2>
          <!--<span class="bg-light-success text-success rounded f-w-600 p-6 m-x-5 p-y-4 f-s-12 justify-content-end">
            Active
          </span>-->
        </div>
        <div class="info-line">
          <mat-icon>email</mat-icon> <span>{{ userEmail }}</span>

        </div>
        @if(this.contactNumber != '' && this.contactNumber != null && this.contactNumber != undefined){
        <div class="info-line">
          <mat-icon>phone</mat-icon> <span>{{contactNumber}}</span>
        </div>
        }
        <!--@if(this.addressLine1 != '' && this.addressLine1 != null && this.addressLine1 != undefined){
        <div class="info-line d-flex align-items-start">
          <mat-icon>location_on</mat-icon> <span>
            {{ addressLine1 }}
          </span>
        </div>
        }

        @if(this.addressLine2 != '' && this.addressLine2 != null && this.addressLine2 != undefined){
        <div class="info-line d-flex align-items-start">
          <mat-icon></mat-icon> <span>
            {{ addressLine2 }}
          </span>
        </div>
        }
        @if(this.addressLine3 != '' && this.addressLine3 != null && this.addressLine3 != undefined){
        <div class="info-line d-flex align-items-start">
          <mat-icon></mat-icon> <span>
            {{ addressLine3 }}
          </span>
        </div>
        }
        @if(this.city != '' && this.city != null && this.city != undefined){
        <div class="info-line d-flex align-items-start">
          <mat-icon></mat-icon> <span>
            {{ city }}
          </span>
        </div>
        }

        @if(this.countyName != '' && this.countyName != null && this.countyName != undefined){
        <div class="info-line d-flex align-items-start">
          <mat-icon></mat-icon> <span>
            {{ countyName }}
          </span>
        </div>
        }

        @if(this.countryName != '' && this.countryName != null && this.countryName != undefined){
        <div class="info-line d-flex align-items-start">
          <mat-icon></mat-icon> <span>
            {{ countryName }}
          </span>
        </div>
        }
        @if(this.postCode != '' && this.postCode != null && this.postCode != undefined){
        <div class="info-line d-flex align-items-start">
          <mat-icon></mat-icon> <span>
            {{ postCode }}
          </span>
        </div>
        }-->


      </div>
    </div>
    <!--<mat-divider class="b-b-1"></mat-divider>-->
    <h3 class="mat-h3 m-y-10" style="font-size: 17px;">Licencing Details</h3>
    <div class="align-content-center p-24 p-t-10 p-b-30">
      <div class="row">
        <!--<div class="col-sm-12 col-md-6 col-lg-6">
    <h4 class="m-0 headercolor m-x-5">Subscription Type:</h4>
    <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px"> {{subscriptionType}} </p>
  </div>-->
        <div class="col-sm-4 m-t-12">
          <h4 class="f-w-400 headercolor f-s-14" style="color: #000;">Subscription Type:</h4>
        </div>
        <div class="col-sm-8 text-right m-t-12">
          <p class="m-0 brand m-x-5 f-s-14 f-w-500" style="font-size: 13px"> {{subscriptionType}} </p>
        </div>
        <!--<div class="col-sm-12  col-md-6 col-lg-6">
    <h4 class="m-0 headercolor m-x-5">Submission Status:</h4>
    <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px"> {{"Live submission for " + noofCharitiesSubmitted + " out of "+noOfCharities+" Charities has been submitted successfully"}} </p>
  </div>-->


        <div class="col-sm-4 m-t-12">
          <h4 class="f-w-400 headercolor f-s-14" style="font-size: 13px; color: #000;">Subscription Start Date:</h4>
        </div>
        <div class="col-sm-8 text-right m-t-12">
          <p class="m-0 brand m-x-5 f-s-14 f-w-500" style="font-size: 13px"> {{subStartDate}} </p>
        </div>

        <div class="col-sm-4 m-t-12">
          <h4 class="f-w-400 headercolor f-s-14" style="font-size: 13px; color: #000;">Subscription End Date:</h4>
        </div>
        <div class="col-sm-8 text-right m-t-12">
          <p class="m-0 brand m-x-5 f-s-14 f-w-500" style="line-height:25px">
            {{subEndDate}}
            @if(this.ShowRenew == true){
            @if(this.leftDays > 1){
            <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
              Expires in {{leftDays}} Days
            </span>
            }  @else if(this.leftDays == 1){
            <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
              Expires in {{leftDays}} Day
            </span>
            }
            @else if(this.expiretoday){
            <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
              Expires Today
            </span>
            }@else{
            <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
              Expired
            </span>
            }
            }
          </p>
        </div>

        <!--<div class="col-sm-4 m-t-12">
    <h4 class="f-w-400 headercolor f-s-16" style="font-size: 13px">User Count:</h4>
  </div>
  <div class="col-sm-8 text-right m-t-12">
    <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="font-size: 13px"> {{numberOfUsers}} </p>
  </div>-->
        <!--<div class="col-sm-4 m-t-12">
    <h4 class="f-w-400 headercolor f-s-16" style="font-size: 13px">Charity Count:</h4>
  </div>
  <div class="col-sm-8 text-right m-t-12">
    <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="font-size: 13px"> {{noOfCharities}} </p>
  </div>-->

        <div class="col-sm-4 m-t-12">
          <h4 class="f-w-400 headercolor f-s-14" style="font-size: 13px; color: #000;">User Status:</h4>
        </div>
        <div class="col-sm-8 text-right m-t-12">
          <p class="m-0 brand m-x-5 f-s-14 f-w-500" style="font-size: 13px"> {{userCount}} out of {{numberOfUsers}} user(s)  has been created  </p>
        </div>


        <div class="col-sm-4 m-t-12">
          <h4 class="f-w-400 headercolor f-s-14" style="font-size: 13px; color: #000;">Charity Status:</h4>
        </div>
        <div class="col-sm-8 text-right m-t-12">
          <p class="m-0 brand m-x-5 f-s-14 f-w-500" style="font-size: 13px"> {{TableRecordCnt}} out of {{noOfCharities}} record(s) has been created  </p>
        </div>

        <div class="col-sm-4 m-t-12">
          <h4 class="f-w-400 headercolor f-s-14" style="font-size: 13px; color: #000;">Submission Status:</h4>
        </div>
        <div class="col-sm-8 text-right m-t-12">
          <p class="m-0 brand m-x-5 f-s-14 f-w-500" style="font-size: 13px"> {{"Live submission for " + noofCharitiesSubmitted + " out of "+noOfCharities+" Charities has been submitted successfully"}} </p>
        </div>




      </div>
      <!--<div class="row m-t-15">
    <div class="col-sm-12  col-md-6 col-lg-6">
      <h4 class="m-0 headercolor m-x-5">Subscription Start Date:</h4>
      <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px"> {{subStartDate}} </p>
    </div>
    <div class="col-sm-12  col-md-6 col-lg-6">
      <h4 class="m-0 headercolor m-x-5">Subscription End Date:</h4>
      <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px">
        {{subEndDate}}
        @if(this.ShowRenew == true){
        @if(this.leftDays > 1){
        <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
          Expires in {{leftDays}} Days
        </span>
        }  @else if(this.leftDays == 1){
        <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
          Expires in {{leftDays}} Day
        </span>
        }
        @else if(this.expiretoday){
        <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
          Expires Today
        </span>
        }@else{
        <span class="bg-light-warning text-warn rounded f-w-600 p-6 p-y-4 f-s-12 m-x-5" style="white-space:nowrap">
          Expired
        </span>
        }
        }
      </p>
    </div>
  </div>-->
      <!--<div class="row m-t-15">
    <div class="col-sm-12  col-md-6 col-lg-6">
      <h4 class="m-0 headercolor m-x-5">User Count:</h4>
      <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px">{{numberOfUsers}}</p>
    </div>
    <div class="col-sm-12  col-md-6 col-lg-6">
      <h4 class="m-0 headercolor m-x-5">Charity Count:</h4>
      <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px">{{noOfCharities}} </p>
    </div>

  </div>
  <div class="row m-t-15">
    <div class="col-sm-12  col-md-6 col-lg-6">
      <h4 class="m-0 headercolor m-x-5">User Status:</h4>
      <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px">{{userCount}} out of {{numberOfUsers}} user(s)  has been created </p>
    </div>
    <div class="col-sm-12  col-md-6 col-lg-6">
      <h4 class="m-0 headercolor m-x-5">Charity Status:</h4>
      <p class="m-0 brand m-x-5 f-s-16 f-w-500" style="line-height:25px"> {{TableRecordCnt}} out of {{noOfCharities}} record(s) has been created </p>
    </div>

  </div>-->

      <mat-divider class="divider w-100" style="border-top-color:#9c9c9c"></mat-divider>

      <h4 class="f-s-14 f-w-400 text-center" style="font-style:italic">
        <span class="m-r-5" style="color: #d8204e; font-size: 13px">Warning:</span>
        <span style="font-size: 13px">This Computer program is protected by copyrights law and international treaties</span>
      </h4>
    </div>
  </div>
</div>
